import styled from 'styled-components'

export const FormStyled = styled.form`
  display: flex;
  flex-wrap: wrap;
`
